import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { TweenMax, Back, Power4 } from 'gsap';

const CounterItemWrapper = styled.div`
  padding: 0px 20px;
  margin-right: 10px;
  @media (max-width: 576px) {
    padding: 0px 10px;
  }
`;
const TopBorder = styled.div`
  height: 4px;
  width: 26px;
  background: #febb39;
`;
const CountNumber = styled.div`
  font-size: 22px;
  color: white;
  font-weight: 900;
  letter-spacing: 0.18px;
  line-height: 36px;
  @media (max-width: 576px) {
    font-size: 16px;
  }
`;
const CountContext = styled.div`
  color: #c2b7c2;
  font-family: AvenirBold;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.12px;
  line-height: 22px;
  @media (max-width: 576px) {
    font-size: 12px;
  }
`;

class CounterItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { num: 0 };
  }
  // updateCounter = updatedNum => {
  //   this.setState({ num: Math.ceil(updatedNum) });
  // };
  updateCounter = (self, prop) => {
    this.setState({ num: Math.ceil(self.target[prop]) });
  };
  componentDidMount() {
    const selectorString = '.counter' + this.props.index;
    // var counter = { var: 0 };
    // const el = document.querySelector(selectorString);
    // // // Start counting
    // counterUp(el, {
    //   duration: 1500,
    //   delay: 5
    // });
    // var textAnimation = new TimelineMax();
    const counter = {
      val: this.state.num
    };

    TweenMax.to(counter, 2, {
      val: this.props.number,
      onUpdate: this.updateCounter,
      // onUpdateParams: [counter.val],
      onUpdateParams: ['{self}', 'val'],
      ease: Power4.easeOut
    });
    // TweenMax.set(selectorString, { x: 0, y: 0, opacity: 0 });
    // TweenMax.to(selectorString, 2, { x: 0, y: 0, opacity: 1 });
    // textAnimation.to(selectorString, 1, { x: 0, y: 0, opacity: 1 });
  }
  render() {
    return (
      <CounterItemWrapper>
        <TopBorder />
        <CountNumber className={'counter' + this.props.index}>
          {/* {this.props.number} */}
          {this.state.num}
        </CountNumber>
        <CountContext>{this.props.title}</CountContext>
      </CounterItemWrapper>
    );
  }
}

CounterItem.propTypes = {
  title: PropTypes.string,
  number: PropTypes.number
};

CounterItem.defaultProps = {
  title: '',
  number: 0
};

export { CounterItem };
